<template>
    <v-container fluid>
        <rule-form
            v-if="model"
            :model="model"
            :titlePrefix="$t('forms.title_prefix.edit')"
            @saved="saved"
        />

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import RuleForm from './Form'
import Rule from '@/models/Rule'
import CycleRule from '@/models/CycleRule'

export default {
    props: {
        id: {
            required: true,
        },
    },

    components: {
        RuleForm,
    },

    data: () => {
        return {
            model: null,
        }
    },

    methods: {
        async findModel() {
            this.model = this.isCycleRule
                ? await new CycleRule().find(this.id)
                : await new Rule().find(this.id)
        },

        saved() {
            this.$router.go(-1)
        },
    },

    computed: {
        isCycleRule() {
            return (
                this.$route.query.cycle_rule === 'true' ||
                this.$route.query.cycle_rule === '1'
            )
        },
    },

    created() {
        this.findModel()
    },
}
</script>

<style></style>
